import { __assign } from 'tslib';
import React__default from 'react';
import { useTheme, Badge } from '@mui/material';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import KButtonAction from '../../KButtons/KButtonAction/index.js';
import { generateButtonSx } from '../../utils/buttonStyle.js';
import { classes } from './index.styled.js';

var BasketToggler = function (_a) {
    var _b = _a.showCount, showCount = _b === void 0 ? true : _b, _c = _a.count, count = _c === void 0 ? 0 : _c, onToggle = _a.onToggle, active = _a.active, backgroundColor = _a.backgroundColor, color = _a.color, icon = _a.icon, className = _a.className, id = _a.id, _d = _a.testId, testId = _d === void 0 ? "BasketToggler" : _d, sx = _a.sx;
    var theme = useTheme();
    var t = useTranslation("refront-components").t;
    var basketTogglerSxStyle = __assign(__assign(__assign({}, sx), generateButtonSx({
        buttonStyle: {
            colors: {
                backgroundColor: backgroundColor,
                textColor: color
            },
            // for the moment, hover color is not customizable from admin, so we must force it to be the same as the background color
            hoverColors: {
                backgroundColor: backgroundColor
            }
        },
        theme: theme
    })), generateButtonSx({
        buttonStyle: {
            colors: {
                backgroundColor: backgroundColor,
                textColor: color,
                borderColor: color || theme.palette.primary.main
            },
            // for the moment, hover color is not customizable from admin, so we must force it to be the same as the background color
            hoverColors: {
                backgroundColor: backgroundColor
            }
        },
        theme: theme,
        styleName: "& .MuiBadge-badge"
    }));
    return (React__default.createElement(KButtonAction, { className: clsx(active && "active", className, "BasketToggler"), onClick: onToggle, "data-testid": testId, title: t("components.basket.basketToggler.title"), id: id, sx: basketTogglerSxStyle },
        React__default.createElement(Badge, { className: classes.count, anchorOrigin: {
                vertical: "top",
                horizontal: "left"
            }, sx: {
                "& .MuiBadge-badge": {
                    left: "-5px",
                    top: "-5px"
                }
            }, max: 99, invisible: !showCount, badgeContent: count }, icon)));
};

export { BasketToggler as default };
//# sourceMappingURL=index.js.map
